module.exports = __webpack_public_path__ + "static/media/csv-file-format-extension.3d312711.svg";